<template>
  <div class="appDownloadBox">
    <div>
      <a :href="downloadLink.appStore">
        <img src="../images/icon2.png" alt="">
      </a>
    </div>
    <div>
      <a :href="downloadLink.playStore">
        <img src="../images/icon1.png" alt="">
      </a>
    </div>
  </div>  
</template>

<script>
export default {
  name: 'AppDownload',
  data () {
    return {
      downloadLink: {
        playStore: 'http://play.google.com/store/apps/details?id=kr.co.eightbyte.safeotp',
        appStore: 'https://apps.apple.com/kr/app/safeotp-%EC%A0%84%EC%9E%90%EC%84%9C%EB%AA%85-%EA%B8%B0%EB%B0%98/id1472679070?mt=8'
      }
    }
  }

  
}
</script>

<style scoped>
  img {
    width: 60px;
  }

/* iPhone 5/SE */
  @media screen and (max-width: 320.98px) {
  }
  @media screen and (min-width: 321px) and (max-width: 599.98px) {
  }
  @media screen and (min-width: 600px) and (max-width: 768.98px) {    
  }

  @media screen and (max-width: 768.98px) {
  } 

  /*  
    PC 버전 
  */
  @media screen and (min-width: 769px) {
  }
  @media screen and (min-width: 769px) and (max-width: 1023.98px) {
  }
  @media screen and (min-width: 1024px) {
  }
  @media screen and (min-width: 2000px) {
    .appDownloadBox img {
      width: 80px!important;
    }
  }
</style>
